import { Entity } from '@backstage/catalog-model';
import { EntityFilter } from '@backstage/plugin-catalog-react';

export type FilterMap = Record<string, EntityFilter | undefined>;

export const countAvailableValues = (
  entities: Entity[],
  filters: FilterMap,
  exclude: string,
  getValues: (entity: Entity) => string[],
): Record<string, number> => {
  const otherFilters = Object.entries(filters)
    .filter(([key, filter]) => key !== exclude && filter?.filterEntity)
    .map(([, filter]) => filter as EntityFilter);

  const counts: Record<string, number> = {};
  entities
    .filter(entity =>
      otherFilters.every(filter =>
        filter.filterEntity ? filter.filterEntity(entity) : true,
      ),
    )
    .forEach(entity => {
      new Set(getValues(entity)).forEach(value => {
        counts[value] = (counts[value] ?? 0) + 1;
      });
    });
  return counts;
};

export const withSelected = (
  counts: Record<string, number>,
  selected: string[],
): string[] =>
  Array.from(new Set([...Object.keys(counts), ...selected])).sort((a, b) =>
    a.localeCompare(b),
  );

export const sameValues = (a: string[], b: string[]) =>
  a.length === b.length && a.every((value, index) => value === b[index]);

export const toStringArray = (value: string | string[] | undefined) =>
  [value].flat().filter((item): item is string => typeof item === 'string');
